/**
 * Checks if project chat is enabled for a given project.
 * Chat is currently disabled only for projects of type 'EMPLOYER'.
 */
const isProjectChatEnabled = (project) => {
  try {
    const projectChatEnabled = project && project.type !== 'EMPLOYER';
    return projectChatEnabled;
  } catch {
    return false;
  }
};

export default isProjectChatEnabled;
